forms-planner-search(class="{show: opts.show}")
  form.form.row(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    .col-12.col-md-6
      inputs-search-radio-order(tag-scope="{ this.tagScope }.inputs.order")
    .col-12.col-md-6
      inputs-search-daterange(tag-scope="{ this.tagScope }.inputs.deadlinerange")
    .col-12.col-md-6
      inputs-complex-search-comma(tag-scope="{ this.tagScope }.inputs.order_ids")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.status")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.order_type")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.client_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.user_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.product_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.responsible_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.material_id")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.stage")
    .col-12
      inputs-search-select-phase(tag-scope="{ this.tagScope }.inputs.phase_id")
    .col-12.col-sm-6.offset-sm-6.col-md-4.offset-md-8.col-lg-2.offset-lg-10
      inputs-search-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('forms.planner.search')
  style(scoped).
    :scope {
      margin-bottom: 30px;
    }
